module.exports = __webpack_public_path__ + "img/visiting-castles.8a5d7a73.svg";